import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth.js';
import { Login } from './pages/Login.js';
import { Splash } from './pages/Splash.js';
import { OrgPicker } from './pages/OrgPicker.js';
import { ProjectPicker } from './pages/ProjectPicker.js';
import { ProjectDesktop } from './pages/ProjectDesktop.js';
export default function App() {
    return (_jsx(AuthProvider, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Splash, {}) }), _jsx(Route, { path: "/login", element: _jsx(Login, {}) }), _jsx(Route, { path: "/orgs", element: _jsx(RequireAuth, { children: _jsx(OrgPicker, {}) }) }), _jsx(Route, { path: "/orgs/:groupId", element: _jsx(RequireAuth, { children: _jsx(ProjectPicker, {}) }) }), _jsx(Route, { path: "/p/:projectId/*", element: _jsx(RequireAuth, { children: _jsx(ProjectDesktop, {}) }) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }) }));
}
function RequireAuth({ children }) {
    const { user, loading } = useAuth();
    const nav = useNavigate();
    if (loading) {
        return (_jsx("div", { className: "splash", children: _jsx("div", { className: "ring" }) }));
    }
    if (!user) {
        nav('/login', { replace: true });
        return _jsx(_Fragment, {});
    }
    return children;
}
export function AppHeader({ rightSlot }) {
    const { user, logout } = useAuth();
    const nav = useNavigate();
    return (_jsxs("header", { className: "app-header", children: [_jsx("div", { className: "brand", onClick: () => nav('/orgs'), style: { cursor: 'pointer' }, children: "FDN" }), _jsx("div", { style: { flex: 1 } }), rightSlot, _jsxs("div", { className: "user", style: { marginLeft: 16 }, children: [_jsx("span", { className: "email", children: user?.email ?? '...' }), _jsx("button", { className: "ghost", style: { marginLeft: 8 }, onClick: () => { void logout().then(() => nav('/login')); }, children: "Sign out" })] })] }));
}
